import { render } from "./NewsButtonReturnToTop.vue?vue&type=template&id=e534b56e&scoped=true"
import script from "./NewsButtonReturnToTop.vue?vue&type=script&lang=js"
export * from "./NewsButtonReturnToTop.vue?vue&type=script&lang=js"

import "./NewsButtonReturnToTop.vue?vue&type=style&index=0&id=e534b56e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e534b56e"

export default script